/* eslint no-nested-ternary: 0 */
/* eslint no-restricted-globals: 0 */
/* eslint no-undef: 0 */
/* eslint valid-typeof: 0 */
/* eslint consistent-return: 0 */
/* eslint no-mixed-operators: 0 */
/* eslint no-unneeded-ternary: 0 */
/* eslint max-len: 0 */
/* eslint no-multi-assign: 0 */
import Cookie from 'common/services/util/-RFC.Cookie';
import * as i18n from 'google-libphonenumber';

/**
 * @ngdoc service
 * @name services.Util
 *
 * @description
 * Utility service to be reused across the application.
 */

angular.module('services')
    .factory('Util', ($window, $state, $timeout, base64, JWT, $filter, $rootScope) => {

        const Util = {
            /**
             * @ngdoc function
             * @name services.Util#capitalizeFirstLetter
             * @methodOf services.Util
             * @function
             *
             * @description
             * Capitalizes the first letter of the given string.
             *
             * @param {String} string String to be capitalized.
             * @returns {String} The given string having the first letter capitalized.
             */
            capitalizeFirstLetter(string) {

                if (!string) {

                    return '';

                }
                return string.charAt(0).toUpperCase() + string.slice(1);

            },

            /**
             * @ngdoc function
             * @name services.Util#base64encode
             * @methodOf services.Util
             * @function
             *
             * @description
             * Encode strings in base64
             * @param {String} value String.
             * @returns {String} Encoded string.
             */
            base64encode(value) {

                return base64.encode(value);

            },

            /**
             * @ngdoc function
             * @name services.Util#base64decode
             * @methodOf services.Util
             * @function
             *
             * @description
             * Decode strings in base64
             * @param {String} value String.
             * @returns {String} Decode string.
             */
            base64decode(value) {

                return base64.decode(value);

            },

            /**
             * @ngdoc function
             * @name services.Util#getScreenWidth
             * @methodOf services.Util
             * @function
             *
             * @description
             * On mobile devices, screen.availWidth stays the same regardless of the orientation
             * of the device.
             *
             * @returns {Number} The screen width.
             */
            getScreenWidth() {

                const orientation =
                    Math.abs($window.orientation) - 90 === 0 ? 'landscape' : 'portrait';
                return (orientation === 'landscape') ? screen.availHeight : screen.availWidth;

            },

            /**
             * @ngdoc function
             * @name services.Util#param
             * @methodOf services.Util
             * @function
             *
             * @description
             * The implementation is identical to $.param. Useful to serialize
             * an array of form elements or a set of key/values into a query string.
             *
             * Below are some examples of objects and their serialized form version.
             *
             * | JSON                                  | Serialized form version      |
             * |---------------------------------------|------------------------------|
             * | 1. {"a": 1, "b": 2}                   | a=1&b=2                      |
             *
             * @param {Object} obj The object to be transformed for a _Post form request_.
             * @returns {String} The _serialized form version_ of the given object.
             */
            param(obj) {

                const s = [];
                const add = (key, value) => {

                    // If value is a function, invoke it and return its value
                    value = angular.isFunction(value) ? value() : (value === null ? '' : value);
                    s[s.length] = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

                };

                // If an array was passed in, assume that it is an array of form elements.
                if (angular.isArray(obj)) {

                    // Serialize the form elements
                    angular.forEach(obj, (value, key) => {

                        add(key, value);

                    });

                } else {

                    // If traditional, encode the "old" way (the way 1.3.2 or older
                    // did it), otherwise encode params recursively.
                    _.each(obj, (value, prefix) => {

                        Util.__buildParams(prefix, obj[prefix], add);

                    });

                }

                // Return the resulting serialization
                return s.join('&').replace(/%20/g, '+');

            },

            /**
             * Helper function for Util.param
             * @param {String} prefix
             * @param {Object} obj
             * @param {Function} add
             */
            __buildParams(prefix, obj, add) {

                if (angular.isArray(obj)) {

                    // Serialize array item.
                    _.each(obj, (value, idx) => {

                        if (/\[\]$/.test(prefix)) {

                            // Treat each array item as a scalar.
                            add(prefix, value);

                        } else {

                            // Item is non-scalar (array or object), encode its numeric index.
                            Util.__buildParams(
                                `${prefix}[${typeof value === 'object' ? idx : ''}]`,
                                value, add,
                            );

                        }

                    });

                } else if (obj !== null && typeof obj === 'object') {

                    // Serialize object item.
                    _.each(obj, (value, name) => {

                        Util.__buildParams(`${prefix}[${name}]`, obj[name], add);

                    });

                } else {

                    // Serialize scalar item.
                    add(prefix, obj);

                }

            },

            /**
             * @ngdoc function
             * @name services.Util#getNameFromEmail
             * @methodOf services.Util
             * @function
             *
             * @description
             * Tries to extract the real name from an email address.
             *
             * @param {String} email The given email address.
             * @returns {String} The real name based on the given email address.
             */
            getNameFromEmail(email) {

                let name = email ? email.split('@')[0] : '';

                if (name) {

                    name = name.replace(/[^a-zA-Z0-9]/g, ' ')
                        .replace(/\s\s+/g, ' ')
                        .replace(/^\s+|\s+$/g, '');

                    return Util.toTitleCase(name);

                }

                return '';

            },

            /**
             * @ngdoc function
             * @name services.Util#toTitleCase
             * @methodOf services.Util
             * @function
             * @description
             * Capitalizes first letter of each word.
             *
             * @param {String} string The string to be titleized.
             * @returns {String} The titleized version of the given string.
             */
            toTitleCase(string) {

                return string.replace(/\w\S*/g, word => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase());

            },

            /**
             * @ngdoc function
             * @name services.Util#getLastScan
             * @methodOf services.Util
             * @function
             *
             * @param {Object} status Instance status
             * @return {Object} The last scan date and vdf update of the given status
             */
            getLastScan(status) {

                let lastScan = 0;
                let lastVdfUpdate = 0;
                const serverTime = moment.utc(status.serverTime).valueOf();

                if (!status) {

                    return { lastScan: false, lastVdfUpdate: false };

                }

                // get last scan time for an AV device
                if (status.data && status.data.lscan && status.data.lscan.date) {

                    lastScan = moment(+status.data.lscan.date * 1000).valueOf();

                }
                // get last scan time for an anonymous AV device
                if (status.data && status.data.status && status.data.status.lscan &&
                    status.data.status.lscan.date) {

                    lastScan = moment(+status.data.status.lscan.date * 1000).valueOf();

                }
                // get the last vdf update time for an AV device
                if (status.data && status.data.about && status.data.about.vdate) {

                    lastVdfUpdate = moment(+status.data.about.vdate * 1000).valueOf();

                }
                // get last scan time for an BK device
                if (status.data && status.data.lastUpdate) {

                    lastScan = moment.utc(status.data.lastUpdate).valueOf();

                }
                // get last scan time for an AT device (iphone)
                if (status.data && status.data.lastScanDate) {

                    lastScan = moment.utc(status.data.lastScanDate).valueOf();

                }
                // get last scan time for an AT device (android)
                if (status.data && status.data.lastLocationDate) {

                    lastScan = moment(status.data.lastLocationDate).valueOf();

                }
                // get last remote session for Pilot overview
                if (status.lastRemoteSession) {

                    lastScan = moment.utc(status.lastRemoteSession).valueOf();

                }
                // get last remote session for Pilot slider
                if (status.date) {

                    lastScan = moment.utc(status.date).valueOf();

                }

                if (lastScan > 0) {

                    lastScan = Math.floor(serverTime - lastScan);
                    if (lastScan === 0) {

                        lastScan = 1;

                    }

                } else {

                    lastScan = false;

                }

                return {
                    lastScan,
                    lastVdfUpdate: (lastVdfUpdate > 0) ?
                        (Math.floor(serverTime - lastVdfUpdate)) : false,
                };

            },

            /**
             * @ngdoc function
             * @name services.Util#inArray
             * @methodOf services.Util
             * @function
             *
             * @description
             * Returns true if value can be found in array or false otherwise.
             * Pass true for 'isSorted' to use a faster binary search when array is sorted.
             *
             * @param {Array} array The array to search in.
             * @param {String} value The value to search for.
             * @param {Boolean} isSorted Is the given array already sorted?
             * @returns {Boolean} Is the value in array?
             */
            inArray(array, value, isSorted) {

                return _.indexOf(array, value, isSorted) === -1;

            },

            /**
             * @ngdoc function
             * @name services.Util#fbSalutation
             * @methodOf services.Util
             * @function
             *
             * @description
             * @param {String} gender Male / Female.
             * @returns {String} Salutation shortcut: Mr / Ms.
             */
            fbSalutation(gender) {

                if (gender === 'male') {

                    return 'MR_';

                } else if (gender === 'female') {

                    return 'MS_';

                }

                return '';

            },

            /**
             * @ngdoc function
             * @name services.Util#elementToStr
             * @methodOf services.Util
             * @function
             *
             * @description
             * Returns a stringified version of a HTML element, based on its id and class
             *
             * @param {Object} el HTMLElement.
             * @returns {String} Stringified element version.
             */
            elementToStr(el) {

                if (!el) {

                    return '';

                }

                const id = el.id ? (`#${el.id}`) : '';
                const className = el.className && typeof el.className === 'string' ? (`.${el.className.split(' ').join('.')}`) : '';
                return el.nodeName.toLowerCase() + id + className;

            },

            /**
             * @ngdoc function
             * @name services.Util#elementOffset
             * @methodOf services.Util
             * @function
             *
             * @description
             * Returns the current coordinates of the element relative to the document
             *
             * @param {Object} el HTMLElement.
             * @returns {Object} HTMLElement top and left coordinates.
             */
            elementOffset(el) {

                let box = { top: 0, left: 0 };
                const doc = el && el.ownerDocument;

                const pYOffset = $window.pageYOffset;
                const pXOffset = $window.pageXOffset;

                if (!doc) {

                    return;

                }

                const docEl = doc.documentElement;

                if (typeof el.getBoundingClientRect !== undefined) {

                    box = el.getBoundingClientRect();

                }

                return {
                    top: box.top + (pYOffset || docEl.scrollTop) - (docEl.clientTop || 0),
                    left: box.left + (pXOffset || docEl.scrollLeft) - (docEl.clientLeft || 0),
                };

            },

            /**
             * @ngdoc function
             * @name services.Util#orderBy
             * @methodOf services.Util
             * @function
             *
             * @description
             * Returns a listed with sorted objects.
             * Similar with _.sortBy in multiple cases, but works better
             * for string comparison.
             *
             * @param {Array} objects THe list of objects to be sorted.
             * @param {String} key The key after which the sort is done.
             * @param {String} order `Asc` for ascending order,
             *      `Desc` for descending order.
             * @param {Function} iterator Function to be applied to the values which
             *  are compared.
             * @returns {Array} List with sorted objects.
             */
            orderBy(objects, key, order, iterator) {

                if (angular.isDefined(order) && order && order.toLowerCase() === 'desc') {

                    order = -1;

                } else {

                    order = 1;

                }

                if (!angular.isFunction(iterator)) {

                    iterator = angular.identity;

                }

                return objects.sort((a, b) => {

                    if (angular.isString(key)) {

                        a = a[key];
                        b = b[key];

                    }
                    a = iterator(a);
                    b = iterator(b);

                    if (a < b) {

                        return -1 * order;

                    } else if (a === b) {

                        return 0;

                    }
                    return 1 * order;

                });

            },

            centerPopup(defaultParams) {

                const width = defaultParams.width || 300;
                const height = defaultParams.height || 200;
                const left = (screen.width - width) / 2;
                const top = (screen.height - height) / 2;
                let params = `width=${width}, height=${height}`;

                params += `, top=${top}, left=${left}`;
                params += ', directories=no';
                params += ', location=no';
                params += ', menubar=no';
                params += ', resizable=no';
                params += ', scrollbars=no';
                params += ', status=no';
                params += ', toolbar=no';

                return params;

            },

            getUserId($stateParams, User) {

                if ($stateParams.userId === 'ftu') {

                    return $stateParams.userId;

                }
                return $stateParams.userId || User.id;

            },

            sanitizeBrowserName(browserName) {

                const name = browserName ? browserName.toLowerCase() : '';

                if (name.indexOf('chrome') !== -1) {

                    return 'Chrome';

                } else if (name.indexOf('firefox') !== -1) {

                    return 'Firefox';

                }

                return browserName;

            },

            /**
             * @ngdoc function
             * @name services.Util#isBeta
             * @methodOf services.Util
             * @function
             *
             * @description
             * Returns a boolean, depending either the current environment is
             * a beta or not.
             */
            isBeta() {

                return $window.location.host.indexOf('beta.') === 0;

            },

            /**
             * @ngdoc function
             * @name service.util#mixpanelDeviceType
             * @methodOf services.Util
             * @function
             *
             * @description
             * Converts device type to mixpanel device type
             */
            mixpanelDeviceType(deviceType) {

                const mixpanelType = {
                    pc: 'PC',
                    laptop: 'laptop',
                    tablet: 'tablet',
                    phone: 'phone',
                };

                return deviceType ? mixpanelType[deviceType.toLowerCase()] : deviceType;

            },

            hasAbs() {

                const el = $window.document.querySelector('.abs-installed');
                return el && el.nodeName.toLowerCase() === 'body';

            },

            /**
             * Return the RegExp object which validates the emails from the whole app.
             * @return RegExp The RegExp object for email validation
             */
            getEmailValidationRegExp() {

                // var acceptedWord = '[-!#$%&\'*+/=?^_`{}|~0-9A-ZÄÖÜäöüß]+';
                const acceptedWord = '[-!#$%&\'*+/=?^_`{}|~0-9A-Z]+'; // no umlauts
                let r = `(^${acceptedWord}(\\.${acceptedWord})*`;
                r = `${r}|`;
                r = `${r}^"([\\001-\\010\\013\\014\\016-\\037!#-\\[\\]-\\177]`;
                r = `${r}|\\\\[\\001-\\011\\013\\014\\016-\\177])*")\\@`;
                // r = r + '(?:[A-Z0-9](?:[A-Z0-9ÄÖÜäöüß-]{0,61}[A-Z0-9])?\\.)+(?:[A-Z]{2,6}|[A-Z0-9-]{2,})\\.?$';
                r = `${r}(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\\.)+(?:[A-Z]{2,6}|[A-Z0-9-]{2,})\\.?$`; // no umlauts

                return new RegExp(r, 'i');

            },

            /**
             * Return the RegExp object which validates the passwords from the whole app.
             * @return RegExp The RegExp object for password validation
             */
            getPasswordValidationRegExp() {

                const r = '^(?=.*?[A-Z])(?=.*?[0-9]).{8,100}$';

                return new RegExp(r);

            },

            /**
             * Returns the password strength via a scoring algorithm.
             */
            getPasswordScore(password) {

                const passwordScorePlugin = require('zxcvbn');
                let passwordScore;

                if (password) {

                    const scoreValue = passwordScorePlugin(password).score;
                    const containsNumber = /\d/.test(password);
                    const containsUppercase = /[A-Z]/.test(password);

                    /*  The scoreValue can have a value between 0 and 4.
                        If the scoreValue is 0 it means that the password is not valid. */
                    if (scoreValue === 0) {

                        passwordScore = {
                            valid: false,
                            value: scoreValue,
                            containsNumber,
                            containsUppercase,
                        };

                    } else {

                        passwordScore = {
                            valid: true,
                            value: scoreValue,
                            containsNumber,
                            containsUppercase,
                        };

                    }
                    return passwordScore;

                }

                return false;

            },

            /**
             * Return the RegExp object which validates the full name from the whole app.
             * @return RegExp The RegExp object for full name validation
             */
            getFullNameValidationRegExp() {

                const r = '^[^:<>"+&%$#*^/\\\\]+$';

                return new RegExp(r, 'i');

            },

            /**
             * Return the RegExp object which validates the generic input from the whole app.
             * @return RegExp The RegExp object for generic input validation
             */
            getGenericInputValidationRegExp() {

                const r = '^[^:<>"+&%$#*^/{}()[\\]\\\\]+$';

                return new RegExp(r, 'i');

            },

            /**
             * Checks if a user is anonymous.
             * @return boolean True if the JWT attribute anon is true
             */
            isAnonymous() {

                const token = Cookie.get(CWCONFIG.cookie.token);

                return (
                    JWT.getTokenPayload(token) &&
                    JWT.getTokenPayload(token).anon === true
                ) ? true : false;

            },

            /**
             * Checks if the client has an operating system with 64bits or not.
             * If the user has MacOs, false is returned.
             */
            is64OS() {

                if ($window.navigator.platform && window.navigator.platform === 'MacIntel') {

                    return false;

                }

                if ($window.navigator.userAgent.indexOf('WOW64') !== -1 ||
                    $window.navigator.userAgent.indexOf('Win64') !== -1) {

                    return true;

                }
                return false;

            },

            /**
             * @param path {string} path
             * @param opts {Object} options
             * @return {?Object}
             *
             * @description
             * Normalizes the given path, returning a regular expression
             * and the original path.
             *
             * Inspired by pathRexp in visionmedia/express/lib/utils.js.
             */
            pathRegExp(path, opts) {

                const insensitive = opts.caseInsensitiveMatch;
                const ret = {
                    originalPath: path,
                    regexp: path,
                };
                const keys = ret.keys = [];

                path = path
                    .replace(/([().])/g, '\\$1')
                    .replace(/(\/)?:(\w+)([?*])?/g, (_, slash, key, option) => {

                        const optional = option === '?' ? option : null;
                        const star = option === '*' ? option : null;
                        keys.push({ name: key, optional: !!optional });
                        slash = slash || '';
                        return `${optional ? '' : slash}(?:${optional ? slash : ''}${star && '(.+?)' || '([^/]+)'}${optional || ''})${optional || ''}`;

                    })
                    .replace(/([/$*])/g, '\\$1');

                ret.regexp = new RegExp(`^${path}$`, insensitive ? 'i' : '');
                return ret;

            },

            /**
             * @ngdoc function
             * @name services.Util#getNextDelimiter
             * @methodOf services.Util
             * @function
             *
             * @description
             * Given an URI path, returns the next delimiter between the path and the query params -
             * it may be ? or &
             *
             * @param {string} path The path
             *
             * @returns {string} The next delimiter: ? or &
             */
            getNextDelimiter(path) {

                let delimiter = '?';
                if (path.indexOf('?') > -1) {

                    delimiter = '&';

                }

                return delimiter;

            },

            /**
             * @ngdoc function
             * @name services.Util#closeModal
             * @methodOf services.Util
             * @function
             *
             * @description
             * Closes a modal.
             *
             * @param {string} nextState If provided, this will be the next state.
             *
             */
            closeModal(nextState) {

                let currentState;

                if (!nextState) {

                    currentState = $state.current.name;

                    nextState = currentState.substr(0, currentState.indexOf('.ltb')) || 'root.dashboard.home';

                }
                $state.go(nextState);

            },

            /**
             * @ngdoc function
             * @name services.Util#deepFind
             * @methodOf services.Util
             * @function
             *
             * @description
             * Get nested object value from path without throwing error.
             *
             * @param {Object} obj obj.
             * @param {string} path path.
             */
            deepFind(obj, path) {

                let current;
                let i;
                if (!obj) {

                    return;

                }

                const paths = path.split('.');
                current = obj;

                for (i = 0; i < paths.length; i += 1) {

                    if (current[paths[i]] === undefined || current[paths[i]] === null) {

                        return;

                    }

                    current = current[paths[i]];

                }

                return current;

            },


            /**
             * @ngdoc function
             * @name services.Util#getDeviceTypeBy
             * @methodOf services.Util
             * @function
             *
             * @description
             * Get device type for a specified os.
             *
             * @param {string} os os.
             */
            getDeviceTypeBy(os) {

                let deviceType;

                switch (os) {

                case 'osx':
                case 'windows':
                    deviceType = 'pc';
                    break;
                case 'ios':
                case 'android':
                    deviceType = 'phone';
                    break;
                default:
                    deviceType = 'pc';

                }

                return deviceType;

            },

            isValidPhoneNumber(phoneNumber, countryCode) {

                let result;
                let phoneUtil;
                let number;
                if (!phoneNumber || !countryCode) {

                    return false;

                }

                result = false;
                const countryCodeUppercase = countryCode.toUpperCase();

                if (!countryCodeUppercase) {

                    return false;

                }

                try {

                    phoneUtil = i18n.PhoneNumberUtil.getInstance();
                    number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCodeUppercase);

                    result = phoneUtil.isValidNumber(number);

                } catch (err) {

                    return false;

                }

                return result;

            },

            getElapsedMilli(date) {

                let currentMilli;
                let eventMilli;
                if (!angular.isNumber(date)) {

                    // convert Date to milliseconds
                    currentMilli = Date.now();
                    eventMilli = new Date(date).getTime();
                    return (currentMilli - eventMilli);

                }

                return date;

            },

            /**
             * @description
             * This method is used to retrieve the authentication token from cookie
             */

            getToken() {

                return Cookie.get(CWCONFIG.cookie.token);

            },

            /**
             * @description
             * This method is used to trigger an animation on html elements
             */

            triggerAnimation(id, animationClass) {

                // make sure this runs in the next tick,
                // so that the element with the class is in the DOM.
                $timeout(() => {

                    angular.element(id).removeClass(animationClass);

                }, 50);

                $timeout(() => {

                    angular.element(id).addClass(animationClass);

                }, 100);

            },

            /**
            * @description
            * This method is used to get the REST resource name from the URL
            */

            getRestResourceFromUrl(url) {

                const regex = /^.*\/v[1-9]\/([a-z0-9-]*).*$/i;
                const parseUrl = url && url.match(regex);

                return parseUrl && parseUrl[1];

            },

            /**
             * @description
             * This method encode strings in MD5
             */

            encodeMD5(string) {

                const crypto = require('crypto-js/md5');

                if (string && crypto) {

                    return crypto(string).toString();

                }

                return false;

            },

            getParams(query) {

                if (!query) {

                    return { };

                }

                return (/^[?#]/.test(query) ? query.slice(1) : query)
                    .split('&')
                    .reduce((params, param) => {

                        const [key, value] = param.split('=');
                        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                        return params;

                    }, { });

            },

            /**
             * @description
             * This method returns the device navigator based on the operating system which
             * is automatically populated by server in index.html => window.deviceOs = '{{ m_os }}';
             * The default case is when the server didn't populate window.deviceOs. Eg. http://localhost
             */

            getDeviceNavigator() {

                const navigator = window.deviceOs.toLowerCase();
                const fallbackNavigator = window.navigator.platform.toLowerCase();

                switch (true) {

                case (navigator.indexOf('windows') > -1):
                    return 'windows';

                case (navigator.indexOf('mac') > -1):
                    return 'osx';

                case (navigator.indexOf('android') > -1):
                    return 'android';

                case (navigator.indexOf('ios') > -1):
                    return 'ios';

                default:
                    if (fallbackNavigator.indexOf('mac') !== -1) {

                        return 'osx';

                    } else if (fallbackNavigator.indexOf('win') !== -1) {

                        return 'windows';

                    }

                    return fallbackNavigator;

                }

            },

            isBrowserCookieEnabled() {

                let isCookieEnabled = navigator.cookieEnabled;

                if (!isCookieEnabled) {

                    document.cookie = 'testcookie';
                    isCookieEnabled = document.cookie.indexOf('testcookie') !== -1;

                }

                return isCookieEnabled;

            },
            isPaymentCardDeleted(paymentTypeDetails) {

                // Get payment type (Debit Card, PayPal, American Express ...)
                const paymentType = paymentTypeDetails && paymentTypeDetails.attributes.payment_type
                    ? paymentTypeDetails.attributes.payment_type.toLowerCase()
                    : '';
                if (paymentTypeDetails &&
                    paymentType.indexOf('paypal') === -1 &&
                    paymentType.indexOf('debit') === -1 &&
                    paymentType.indexOf('voucher') === -1 &&
                    paymentType.indexOf('wire transfer') === -1) {

                    // If the last digits are missing from payment details, it means the card was removed
                    return !(paymentTypeDetails.attributes.last_digits);

                }
                return false;

            },
            // this is to check if the appId is one of the app that we no longer promote upsell in dashboard
            isNonrenewableApp(appId) {

                const { nonrenewableApps } = CWCONFIG;
                return !!(nonrenewableApps.find(id => id === appId));

            },

            /**
             * Maps an ISO 639-1 two-letter language code to an ISO 639-2 alpha-3 code.
             * Returns 'ENG' as the fallback for unrecognised codes.
             */
            getIso3LangCode(lang) {

                const LANG_TO_ISO3 = {
                    en: 'ENG',
                    de: 'DEU',
                    fr: 'FRA',
                    es: 'SPA',
                    it: 'ITA',
                    ru: 'RUS',
                    nl: 'NLD',
                    pl: 'POL',
                    pt: 'POR',
                    'pt-br': 'POR',
                    ja: 'JPN',
                    tr: 'TUR',
                    'zh-cn': 'ZHO',
                    'zh-tw': 'ZHO',
                };
                return LANG_TO_ISO3[lang] || 'ENG';

            },

            /**
             * Maps an ISO 3166-1 alpha-2 country code to an ISO 3166-1 alpha-3 code.
             * Falls back to the provided fallback value (or 'ENG') when the code is not found.
             */
            getIso3CountryCode(country, fallback) {

                const COUNTRY_TO_ISO3 = {
                    AT: 'AUT',
                    BE: 'BEL',
                    BG: 'BGR',
                    HR: 'HRV',
                    CY: 'CYP',
                    CZ: 'CZE',
                    DK: 'DNK',
                    EE: 'EST',
                    FI: 'FIN',
                    FR: 'FRA',
                    DE: 'DEU',
                    GR: 'GRC',
                    HU: 'HUN',
                    IE: 'IRL',
                    IT: 'ITA',
                    LV: 'LVA',
                    LT: 'LTU',
                    LU: 'LUX',
                    MT: 'MLT',
                    NL: 'NLD',
                    PL: 'POL',
                    PT: 'PRT',
                    RO: 'ROU',
                    SK: 'SVK',
                    SI: 'SVN',
                    ES: 'ESP',
                    SE: 'SWE',
                };
                return COUNTRY_TO_ISO3[country] || fallback || 'ENG';

            },

            compareString(stringOne, stringTwo) {

                if (stringOne && stringTwo) {

                    stringOne = stringOne.toLowerCase();
                    stringTwo = stringTwo.toLowerCase();

                    if (stringOne.length < stringTwo.length) {

                        return stringTwo.indexOf(stringOne) > -1;

                    }
                    return stringOne.indexOf(stringTwo) > -1;

                }

                return false;

            },
            /**
             * @description
             * This method is used to retrieve the remaining runtime until expiration date
             * @param
             * activation code or license
             */
            getRemainingRuntime(activationCode) {

                const expirationDate = this.deepFind(activationCode, 'attributes.date_expire') || this.deepFind(activationCode, 'attributes.expiration_date');
                const startTime = moment();
                const endTime = moment(expirationDate);
                return parseInt(moment.duration(endTime.diff(startTime)).asDays(), 10) + 1;

            },
            /**
             * @description
             * This method is used to get extra runtime of a license after a merge(new purchase, OCP, renew)
             * @param
             * license
             */
            getExtraRuntime(license) {

                const currentRuntime = this.getRemainingRuntime(license);
                const purchasedRuntime = parseInt(this.deepFind(license, 'attributes.runtime'), 10);
                let purchaseRuntimeAsDays;
                switch (purchasedRuntime) {

                case 1:
                    purchaseRuntimeAsDays = 30;
                    break;
                case 12:
                    purchaseRuntimeAsDays = 365;
                    break;
                case 24:
                    purchaseRuntimeAsDays = 730;
                    break;
                case 36:
                    purchaseRuntimeAsDays = 1095;
                    break;
                default: purchaseRuntimeAsDays = currentRuntime;

                }

                return currentRuntime - purchaseRuntimeAsDays;

            },
            // this function is used to update the lastLogin object in local storage in order to show simplified Log in view
            updateLastLoginObjectInLocalStorage(userObject) {

                const loginObject = {
                    firstName: $filter('friendName')(userObject),
                    lastName: this.deepFind(userObject, 'attributes.last_name'),
                    email: this.deepFind(userObject, 'attributes.email'),
                    profilePic: this.deepFind(userObject, 'attributes.profile_image_medium'),
                    loginType: Cookie.get(CWCONFIG.cookie.loginType),
                };

                const encodedLoginObject = Util.base64encode(JSON.stringify(loginObject));

                localStorage.setItem('lastLogin', encodedLoginObject);

            },

            // this function is used to get the page name
            getPageName() {

                const urlName = $state.current.name;
                const splitedUrl = urlName.split('.');

                if (splitedUrl[2]) {

                    let pageName = Util.capitalizeFirstLetter(splitedUrl[2]);

                    if (splitedUrl[2] === 'store') {

                        if ($rootScope.isPrimeStore) {

                            pageName = 'Prime Store Page';

                        } else {

                            pageName = 'Comparison Store Page';

                        }

                    }

                    if (splitedUrl[2] === 'home') {

                        pageName = 'Homepage';

                    }

                    if (splitedUrl[2] === 'devices') {

                        pageName = 'My devices';

                    }

                    return pageName;

                }

                return '';

            },

            toFixed(num, fixed) {

                if (Math.abs(num) < 1.0) {

                    const e = parseInt(num.toString().split('e-')[1], 0);
                    if (e) {

                        // eslint-disable-next-line no-restricted-properties
                        num *= Math.pow(10, e - 1);
                        num = `0.${(new Array(e)).join('0')}${num.toString().substring(2)}`;

                    }

                } else {

                    let e = parseInt(num.toString().split('+')[1], 0);
                    if (e > 20) {

                        e -= 20;
                        // eslint-disable-next-line no-restricted-properties
                        num /= Math.pow(10, e);
                        num += (new Array(e + 1)).join('0');

                    }

                }

                num = num.toString();
                let formattedNum = num;

                if (num.length > 8) {

                    const re = new RegExp(`^-?\\d+(?:.\\d{0,${fixed || -1}})?`);
                    const modifiedNum = num.toString().match(re)[0];
                    formattedNum = modifiedNum;

                }

                return formattedNum;

            },

        };

        return Util;

    });



// WEBPACK FOOTER //
// ./scripts/common/services/util/Util.js